<div
  id="toast-container"
  class="toast-container pointer-events-none fixed top-[4.5em] right-4 z-[9999] flex flex-col gap-2"
>
  @for (toast of toasts$ | async; track toast.id) {
    <div
      (click)="dismiss(toast.id)"
      class="pointer-events-auto flex max-w-sm min-w-64 cursor-pointer items-center justify-center rounded px-4 py-3 text-center text-sm font-semibold text-white shadow-lg transition-all duration-300 ease-in-out starting:translate-x-4 starting:opacity-0"
      [ngClass]="{
        'bg-green-600': toast.type === ToastType.SUCCESS,
        'bg-errorRed': toast.type === ToastType.ERROR,
        'translate-x-4 opacity-0': toast.removing,
      }"
    >
      {{ toast.message }}
    </div>
  }
</div>
